var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"logo"},[(_vm.isShowImg)?_c('img',{staticClass:"logo-image",attrs:{"src":_vm.logoImg_big}}):_c('img',{staticClass:"logo-image",attrs:{"src":_vm.logoImg_Small}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }